module.exports = __webpack_public_path__ + "img/3.89f43b74.png";